(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lr-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lr-header')) {
    customElements.define(
      'lr-header',
      class LrHeader extends HTMLElement {
        connectedCallback() {
          this.drawer = this.querySelector('.lr-header__drawer');
          this.onCart = (event) => {
            const count = event.detail && event.detail.itemCount;
            if (typeof count !== 'number') return;
            this.querySelectorAll('[data-lr-cart-count]').forEach((el) => {
              el.textContent = count;
              el.hidden = count === 0;
            });
          };
          this.onKey = (event) => {
            if (event.key === 'Escape' && this.drawer && this.drawer.open) {
              this.drawer.open = false;
              this.drawer.querySelector('summary').focus();
            }
          };
          this.onClick = (event) => {
            if (event.target.closest('.lr-header__panel a')) this.drawer.open = false;
          };
          document.addEventListener('lr:cart-updated', this.onCart);
          document.addEventListener('keydown', this.onKey);
          this.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          document.removeEventListener('lr:cart-updated', this.onCart);
          document.removeEventListener('keydown', this.onKey);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lr-join-the-rebellion"] && !Shopify.designMode) return;
  try {
    
  // After a successful post Shopify reloads the page; bring the confirmation into view
  document.querySelectorAll('.lr-join__success').forEach((el) => {
    el.scrollIntoView({ block: 'center' });
    el.focus({ preventScroll: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lr-meet-the-rebels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lr-product-card')) {
    customElements.define(
      'lr-product-card',
      class LrProductCard extends HTMLElement {
        connectedCallback() {
          this.toggle = this.querySelector('[data-toggle]');
          this.art = this.querySelector('[data-art]');
          this.photo = this.querySelector('[data-photo]');
          this.form = this.querySelector('form.lr-card__form');
          this.photoLabel = this.toggle ? this.toggle.textContent.trim() : '';

          if (this.toggle) this.toggle.addEventListener('click', () => this.togglePhoto());
          if (this.form) this.form.addEventListener('submit', (event) => this.addToCart(event));
        }

        togglePhoto() {
          const showPhoto = this.photo.hidden;
          this.photo.hidden = !showPhoto;
          this.art.hidden = showPhoto;
          this.toggle.setAttribute('aria-pressed', String(showPhoto));
          this.toggle.textContent = showPhoto ? this.toggle.dataset.productLabel : this.photoLabel;
        }

        async addToCart(event) {
          // Progressive enhancement: without JS the form posts to /cart/add normally
          if (!window.fetch) return;
          event.preventDefault();

          const button = this.form.querySelector('[type="submit"]');
          const status = this.form.querySelector('[role="status"]');
          const label = button.textContent;
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          status.textContent = '';

          try {
            const response = await fetch(`${this.form.getAttribute('action')}.js`, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(this.form),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart');

            const cart = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
            document.dispatchEvent(new CustomEvent('lr:cart-updated', { detail: { itemCount: cart.item_count, cart } }));

            button.textContent = 'Added!';
            status.textContent = `${data.product_title || 'Item'} added to your cart.`;
            setTimeout(() => {
              button.textContent = label;
              button.disabled = false;
            }, 1600);
          } catch (error) {
            status.textContent = error.message;
            button.textContent = label;
            button.disabled = false;
          } finally {
            button.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lr-where-to-buy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lr-store-locator')) {
    customElements.define(
      'lr-store-locator',
      class LrStoreLocator extends HTMLElement {
        connectedCallback() {
          this.query = '';
          this.region = '';
          this.markers = new Map();
          this.stores = Array.from(this.querySelectorAll('[data-store]'));
          this.empty = this.querySelector('[data-empty]');
          this.mapEl = this.querySelector('[data-map]');
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          const search = this.querySelector('[data-search]');
          if (search) {
            search.addEventListener('input', () => {
              this.query = search.value.trim().toLowerCase();
              this.filter();
            });
          }

          this.querySelectorAll('[data-region]').forEach((chip) => {
            if (!chip.matches('button')) return;
            chip.addEventListener('click', () => {
              this.region = chip.dataset.region;
              this.querySelectorAll('button[data-region]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
              this.filter();
            });
          });

          this.stores.forEach((store) => {
            const pick = store.querySelector('[data-pick]');
            if (pick) pick.addEventListener('click', () => this.pick(store));
            const link = store.querySelector('a.lr-locator__btn');
            if (link) link.addEventListener('click', () => this.setActive(store));
          });

          // Only load map tiles once the locator is near the viewport
          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.observer.disconnect();
                this.whenLeaflet(() => this.initMap());
              }
            },
            { rootMargin: '300px' }
          );
          this.observer.observe(this.mapEl);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.map) {
            this.map.remove();
            this.map = null;
          }
        }

        whenLeaflet(callback) {
          if (window.L) return callback();
          const script = document.getElementById('lr-leaflet-js');
          if (script) script.addEventListener('load', callback, { once: true });
        }

        coords(store) {
          const lat = parseFloat(store.dataset.lat);
          const lng = parseFloat(store.dataset.lng);
          return Number.isFinite(lat) && Number.isFinite(lng) ? [lat, lng] : null;
        }

        initMap() {
          if (this.map || !window.L) return;
          const L = window.L;
          const map = L.map(this.mapEl, { scrollWheelZoom: false }).setView([43.5, -88], 5);
          L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
            attribution: '&copy; OpenStreetMap &copy; CARTO',
            maxZoom: 19,
            subdomains: 'abcd',
          }).addTo(map);
          map.on('click', () => map.scrollWheelZoom.enable());

          const bounds = [];
          this.stores.forEach((store) => {
            const latLng = this.coords(store);
            if (!latLng) return;
            const icon = L.divIcon({
              className: '',
              html: `<div class="lr-map-pin" style="background:${store.dataset.color}"><span>${store.dataset.status === 'coming_soon' ? '✦' : ''}</span></div>`,
              iconSize: [28, 28],
              iconAnchor: [14, 28],
              popupAnchor: [0, -28],
            });
            const marker = L.marker(latLng, { icon, title: store.dataset.name }).addTo(map);
            marker.bindPopup(this.popup(store));
            marker.on('click', () => this.setActive(store));
            this.markers.set(store, marker);
            bounds.push(latLng);
          });

          if (bounds.length) map.fitBounds(L.latLngBounds(bounds), { padding: [50, 50], maxZoom: 11 });
          this.map = map;
        }

        popup(store) {
          const wrap = document.createElement('div');
          const name = document.createElement('div');
          name.className = 'lr-popup__name';
          name.textContent = store.dataset.name;
          const addr = document.createElement('div');
          addr.className = 'lr-popup__addr';
          addr.textContent = store.dataset.address;
          const link = document.createElement('a');
          link.className = 'lr-popup__link';
          link.href = store.dataset.directions;
          link.target = '_blank';
          link.rel = 'noopener';
          link.textContent = this.dataset.directionsLabel;
          wrap.append(name, addr, link);
          return wrap;
        }

        setActive(store) {
          this.stores.forEach((s) => s.classList.toggle('is-active', s === store));
        }

        pick(store) {
          this.setActive(store);
          const latLng = this.coords(store);
          if (!latLng || !this.map) return;
          if (this.reduceMotion) this.map.setView(latLng, 13);
          else this.map.flyTo(latLng, 13, { duration: 0.6 });
          const marker = this.markers.get(store);
          if (marker) marker.openPopup();
        }

        filter() {
          let visible = 0;
          this.stores.forEach((store) => {
            const matchRegion = !this.region || store.dataset.region === this.region;
            const matchQuery = !this.query || store.dataset.search.includes(this.query);
            store.hidden = !(matchRegion && matchQuery);
            if (!store.hidden) visible += 1;
          });
          this.empty.hidden = visible > 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
